require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-architecture-an-essay-on-the-intersection-of-classicism-modern-technology.json") })
        }
      }, "path---journal-architecture-an-essay-on-the-intersection-of-classicism-modern-technology");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-architecture-an-essay-on-the-intersection-of-classicism-modern-technology!./.cache/json/journal-architecture-an-essay-on-the-intersection-of-classicism-modern-technology.json
// module id = 453
// module chunks = 231608221292675